export default __webpack_public_path__ + "static/media/king.3e50f52c.png";